import { useEffect, useState } from 'react';
import { isSameDay } from 'date-fns';

function hasBudgetStatusBeenSeenToday(lastSeenBudgetStatus) {
  if (!lastSeenBudgetStatus) {
    return false;
  }

  return isSameDay(Number(lastSeenBudgetStatus), Date.now());
}

function useRenderBudgetStatusBadge() {
  const [isShowing, setIsShowing] = useState(false);

  useEffect(() => {
    const lastSeen = window.localStorage.getItem('lastSeenBudgetStatus');

    if (hasBudgetStatusBeenSeenToday(lastSeen)) {
      setIsShowing(false);
    } else {
      setIsShowing(true);
    }
  }, []);

  return isShowing;
}

export default useRenderBudgetStatusBadge;
